import React from 'react';
import { useVariantEdit } from '../VariantEditContext';
import { useVariants } from '../VariantsContext';
import Button from '@dashboard/components/Button';
import Reorderable from '@dashboard/components/Reorderable';
import { Accordion } from '@dashboard/components/ui/accordion';
import VariantItem from './VariantItem';

export default function VariantsList() {
  const { state: variants } = useVariants();
  const { isAddingVariant, onReorderVariants, onAddVariant, setIsEditingVariant } =
    useVariantEdit();

  const openVariant = variants.find(variant => variant.isEditing);
  const openValue = openVariant ? openVariant._id || openVariant.key : '';

  const handleValueChange = value => {
    if (value) {
      setIsEditingVariant(true, value);
    } else if (openVariant) {
      setIsEditingVariant(false, openVariant._id || openVariant.key);
    }
  };

  return (
    <div>
      {variants.length > 0 && (
        <div className="mb-4">
          <Accordion
            type="single"
            collapsible
            value={openValue}
            onValueChange={handleValueChange}
            className="border-t"
          >
            <Reorderable.Wrapper>
              <Reorderable
                id="variants"
                items={variants}
                onReorder={onReorderVariants}
                renderItem={({ item: variant, dragHandleProps, isDragging }) => (
                  <Reorderable.Item isDragging={isDragging}>
                    <VariantItem variant={variant} dragHandleProps={dragHandleProps} />
                  </Reorderable.Item>
                )}
              />
            </Reorderable.Wrapper>
          </Accordion>
        </div>
      )}

      {!isAddingVariant && (
        <div className="flex">
          <Button handleClick={onAddVariant} appearance="primary">
            + Add variant
          </Button>
        </div>
      )}
    </div>
  );
}
